export default __webpack_public_path__ + "static/media/browseSamll.8c774920.png";